import React from 'react';
import { Icon } from './Icon.js';
export const IconCaretMaximizeDiagonal2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M5 11.976L5.96276 11.9759L12 6L12 5L5 5L5 11.976Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M19 12.024L18.0372 12.0241L12 18L12 19L19 19L19 12.024Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconCaretMaximizeDiagonal2.js.map